import { createCollectionStatusReducer, createCollectionReducer } from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import Page from '../interfaces/page';

const list = createCollectionReducer<Page>(ActionTypes.FETCH_PAGE_SUCCESS);
const status = createCollectionStatusReducer(
  ActionTypes.FETCH_PAGE_REQUEST,
  ActionTypes.FETCH_PAGE_NOT_FOUND,
  ActionTypes.FETCH_PAGE_ERROR,
  ActionTypes.FETCH_PAGE_SUCCESS
);

export default combineReducers({
  list,
  status
});
